import { Navigate } from "react-router-dom";

import { NamedRoute } from "@/jenesys-types/routes/routes";

import setupBankStatementDocumentsRoute from "./ClientBankStatementDocumentsRoute";
import setupBillingRoute from "./ClientBillingRoute";
import setupConnectionsDetailRoute from "./ClientConnectionsDetailRoute";
import setupConnectionsRoute from "./ClientConnectionsRoute";
import setupLineItemExtractionRoute from "./ClientLineItemExtractionRoute";
import setupPractiseProfileRoute from "./ClientPractiseProfileRoute";
import { ClientSettingsRoute } from "./ClientSettingsTabbedRoute";
import setupTeamRoute from "./ClientTeamRoute";

// eslint-disable-next-line import/no-anonymous-default-export
export default (): NamedRoute => ({
  path: "settings",
  name: "settings.client",
  element: <ClientSettingsRoute />,
  children: [
    { index: true, element: <Navigate replace to="practise-profile" /> },
    setupPractiseProfileRoute(),
    setupConnectionsRoute(),
    setupConnectionsDetailRoute(),
    setupTeamRoute(),
    setupBillingRoute(),
    setupBankStatementDocumentsRoute(),
    setupLineItemExtractionRoute()
  ]
});
